import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { usePartyAuth } from '../contexts/PartyAuthContext';
import client from '../api/client';

export default function PartyCandidates() {
  const { party } = usePartyAuth();
  const navigate = useNavigate();
  const [candidates, setCandidates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!party) { navigate('/party/login'); return; }
    client.get('/party/candidates').then(res => {
      const data = res.data;
      data.sort((a, b) => b.vote_count - a.vote_count);
      setCandidates(data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [party, navigate]);

  const grouped = candidates.reduce((acc, c) => {
    const key = c.constituency_name;
    if (!acc[key]) acc[key] = [];
    acc[key].push(c);
    return acc;
  }, {});

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>Party Candidates</h1>
        <Link to="/party/dashboard" className="btn-secondary">Back</Link>
      </div>
      {loading ? <p>Loading...</p> : (
        Object.entries(grouped).map(([constituency, cands]) => (
          <div key={constituency} className="card">
            <h2>{constituency}</h2>
            <table>
              <thead>
                <tr>
                  <th>Rank</th>
                  <th>Candidate</th>
                  <th>Votes</th>
                </tr>
              </thead>
              <tbody>
                {cands.map((c, idx) => (
                  <tr key={c.id}>
                    <td>#{idx + 1}</td>
                    <td>{c.name}</td>
                    <td>{c.vote_count}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))
      )}
    </div>
  );
}
